import React from 'react';
import { Loader2, Brain, TrendingUp, Target, Award } from 'lucide-react';

const AnalysisLoadingModal = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
        {/* Main Loading Animation */}
        <div className="flex flex-col items-center">
          {/* Spinning Brain Icon */}
          <div className="relative mb-6">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full blur-xl opacity-50 animate-pulse"></div>
            <div className="relative bg-gradient-to-br from-blue-500 to-purple-600 p-6 rounded-full">
              <Brain className="w-12 h-12 text-white animate-pulse" />
            </div>
            <Loader2 className="absolute -inset-2 w-[calc(100%+1rem)] h-[calc(100%+1rem)] text-blue-500 animate-spin" />
          </div>

          {/* Main Text */}
          <h3 className="text-2xl font-bold text-slate-900 mb-2">
            Анализируем тренировку
          </h3>
          <p className="text-sm text-slate-500 text-center mb-8">
            AI обрабатывает диалог и готовит детальную обратную связь
          </p>

          {/* Processing Steps */}
          <div className="w-full space-y-4">
            <AnalysisStep
              icon={<Target className="w-4 h-4" />}
              text="Оценка достижения целей"
              delay="0s"
            />
            <AnalysisStep
              icon={<TrendingUp className="w-4 h-4" />}
              text="Анализ сильных и слабых сторон"
              delay="0.5s"
            />
            <AnalysisStep
              icon={<Award className="w-4 h-4" />}
              text="Формирование рекомендаций"
              delay="1s"
            />
          </div>

          {/* Progress Bar */}
          <div className="w-full mt-8">
            <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-blue-500 to-purple-600 rounded-full animate-progress"></div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes progress {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }
        .animate-progress {
          animation: progress 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

const AnalysisStep = ({ icon, text, delay }) => {
  return (
    <div
      className="flex items-center gap-3 text-sm text-slate-600 animate-fade-in"
      style={{ animationDelay: delay }}
    >
      <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
        {icon}
      </div>
      <span>{text}</span>
      <div className="flex-1 flex justify-end">
        <Loader2 className="w-4 h-4 text-slate-400 animate-spin" />
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateX(-10px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        .animate-fade-in {
          animation: fade-in 0.5s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </div>
  );
};

export default AnalysisLoadingModal;
